// Handles the "open a chat with this venue" flow from the guest map:
//   - Guards on an active QR pass (surfaces a toast if the guest doesn't
//     hold one, since new-conversation entry is QR-gated).
//   - Tracks `openingVenueId` so the caller can render a spinner on the
//     tapped card.
//   - Opens/creates the conversation via /api/messages/open-conversation
//     and navigates the guest into the chat.

import { useCallback, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function useOpenVenueChat({ hasActivePass }) {
  const navigate = useNavigate();
  const [openingVenueId, setOpeningVenueId] = useState(null);

  const openVenueChat = useCallback(async (venue) => {
    const token = localStorage.getItem('token');
    if (!token || openingVenueId === venue.id) return;
    if (!hasActivePass) {
      toast('Only guests with an active QR pass can message venues.', {
        duration: 3500,
        id: `msg-gate-${venue.id}`,
      });
      return;
    }
    setOpeningVenueId(venue.id);
    try {
      const response = await axios.post(
        `${API}/messages/open-conversation`,
        { recipient_id: venue.id },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      navigate(`/guest/chat/${response.data.id}`);
    } catch (error) {
      console.error('Failed to open venue chat:', error);
    } finally {
      setOpeningVenueId(null);
    }
  }, [navigate, openingVenueId, hasActivePass]);

  return { openVenueChat, openingVenueId };
}
